import React from 'react';
// import v from '../assets/reimu.mp4';
import v from '../assets/main.jpg';

export default function Home() {

  return (
    <main className="relative z-0">
      {/* <video
        id="home-video"
        className="absolute object-cover w-full h-full"
        autoPlay
        loop
        muted
      >
        <source src={`https://upos-sz-mirrorkodo.bilivideo.com/upgcxcode/09/39/129633909/129633909-1-208.mp4?e=ig8euxZM2rNcNbKV7WdVhwdl7wdBhwdVhoNvNC8BqJIzNbfq9rVEuxTEnE8L5F6VnEsSTx0vkX8fqJeYTj_lta53NCM=&uipk=5&nbs=1&deadline=1607703280&gen=playurl&os=kodobv&oi=978800370&trid=40c114bb34ec4ef4aa821cd2b8c3b431T&platform=html5&upsig=6c05e794c1fd640422d8498c14436993&uparams=e,uipk,nbs,deadline,gen,os,oi,trid,platform&mid=524602686&orderid=0,1&logo=80000000`} type="video/mp4"></source>
      </video> */}
      <img 
        src={v}
        alt="background"
        className="absolute object-cover w-full h-full"
      />
      <section
        className="relative flex justify-center min-h-screen pt-12 lg:pt-64 px-8"
      >
        <h1 
          className="text-6xl text-green-100 font-bold cursive leading-none lg:leading-snug home-name"
        >
          Life and dream
        </h1>
      </section>
    </main>
  ) 
}
